import { useQueryDownloader } from '@trinity/chat-components/containers/QueryDownloader/index.js';
import type { DownloadTranscriptClipParams } from '../context';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';

export const useDownloadTranscriptClip = (props: DownloadTranscriptClipParams) => {

  const apiClient = useChatApiClient();

  return useQueryDownloader({
    queryKey: [
      `get:transcript/clip`,
      props,
    ],
    queryFn: ({ queryKey }) => {
      const params = queryKey[1];
      return apiClient.transcripts.downloadTranscriptClip(params);
    },
    downloaderOptions: {
      onResponse: res => ({
        type: 'websocket',
        value: res.websocketKey,
      }),
    },
  });
};